import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useAccordionDndContext, accordionDragType } from '../AccordionDndContext/AccordionDndContext.js';
import { useAccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);

var AccordionItemDndContext = function AccordionItemDndContext(_ref) {
  var children = _ref.children;
  var dndContext = useAccordionDndContext();

  var _useAccordionItemCont = useAccordionItemContext(),
      itemId = _useAccordionItemCont.itemId,
      headerContent = _useAccordionItemCont.headerContent;

  var dragItem = {
    itemId: itemId,
    headerContent: headerContent
  };

  var _useDrag = useDrag(function () {
    return {
      canDrag: function canDrag() {
        return !!(dndContext !== null && dndContext !== void 0 && dndContext.onDragChange) && !!(dndContext !== null && dndContext !== void 0 && dndContext.canDrag && dndContext.canDrag(dragItem));
      },
      collect: function collect(monitor) {
        return {
          canDragAccordion: monitor.canDrag(),
          isDragging: monitor.isDragging()
        };
      },
      item: dragItem,
      type: accordionDragType
    };
  }, [dndContext, dragItem]),
      _useDrag2 = _slicedToArray(_useDrag, 3),
      _useDrag2$ = _useDrag2[0],
      canDragAccordion = _useDrag2$.canDragAccordion,
      isDragging = _useDrag2$.isDragging,
      connectDragSource = _useDrag2[1],
      connectDragPreview = _useDrag2[2];

  var canDrop = function canDrop(_source) {
    return !!dndContext && !!dndContext.onDragChange && !!(dndContext.canDrop && dndContext.canDrop(dragItem ? dragItem : void 0));
  };

  var drop = function drop(position) {
    return function (source) {
      if (dndContext && dndContext.onDragChange) {
        dndContext.onDragChange({
          position: position,
          source: source,
          target: dragItem
        });
      }
    };
  };

  var _useDrop = useDrop(function () {
    return {
      accept: accordionDragType,
      canDrop: canDrop,
      drop: drop("before"),
      collect: function collect(monitor) {
        return {
          canDropTopBar: monitor.canDrop(),
          isDragOverTopBar: monitor.isOver()
        };
      }
    };
  }, [dndContext, dragItem]),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      canDropTopBar = _useDrop2$.canDropTopBar,
      isDragOverTopBar = _useDrop2$.isDragOverTopBar,
      connectDropTopBarTarget = _useDrop2[1];

  var _useDrop3 = useDrop(function () {
    return {
      accept: accordionDragType,
      canDrop: canDrop,
      drop: drop("after"),
      collect: function collect(monitor) {
        return {
          canDropBottomBar: monitor.canDrop(),
          isDragOverBottomBar: monitor.isOver()
        };
      }
    };
  }, [dndContext, dragItem]),
      _useDrop4 = _slicedToArray(_useDrop3, 2),
      _useDrop4$ = _useDrop4[0],
      canDropBottomBar = _useDrop4$.canDropBottomBar,
      isDragOverBottomBar = _useDrop4$.isDragOverBottomBar,
      connectDropBottomBarTarget = _useDrop4[1];

  React.useEffect(function () {
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [connectDragPreview]);
  var context = React.useMemo(function () {
    return {
      canDragAccordion: canDragAccordion,
      isDragging: isDragging,
      canDropTopBar: canDropTopBar,
      isDragOverTopBar: isDragOverTopBar,
      canDropBottomBar: canDropBottomBar,
      isDragOverBottomBar: isDragOverBottomBar,
      connectDragSource: connectDragSource,
      connectDropTopBarTarget: connectDropTopBarTarget,
      connectDropBottomBarTarget: connectDropBottomBarTarget
    };
  }, [canDragAccordion, isDragging, canDropTopBar, isDragOverTopBar, canDropBottomBar, isDragOverBottomBar, connectDragSource, connectDropTopBarTarget, connectDropBottomBarTarget]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: children
  });
};

AccordionItemDndContext.propTypes = {
  "children": _PropTypes.node
};
AccordionItemDndContext.displayName = "AccordionItemDndContext";
function useAccordionItemDndContext() {
  return React.useContext(Context);
}

export { AccordionItemDndContext, useAccordionItemDndContext };
